import { useMutation } from "@tanstack/react-query";

import { profileApi } from "@/features/profile/services/profile.api";

/** No local state to clear on success — unlike a full logout, a password
 * change only bumps the server-side `tokenVersion` (invalidating *refresh*
 * tokens; see server/src/services/profile.service.ts), so the current
 * short-lived access token keeps working until it naturally expires. The
 * user isn't abruptly logged out mid-change. */
export function useChangePassword() {
  return useMutation({
    mutationFn: profileApi.changePassword,
  });
}
